import React from 'react';
import { Risk } from '../../types/risk';

interface RiskMatrixProps {
  risks: Risk[];
  onRiskSelect: (risk: Risk) => void;
}

export default function RiskMatrix({ risks, onRiskSelect }: RiskMatrixProps) {
  const impactLevels = ['low', 'medium', 'high'];
  const probabilityLevels = ['low', 'medium', 'high'];

  const getRisksForCell = (impact: string, probability: string) => {
    return risks.filter(risk => 
      risk.impact === impact && risk.probability === probability
    );
  };

  const getCellColor = (impact: string, probability: string) => {
    if (impact === 'high' && probability === 'high') return 'bg-red-50';
    if (impact === 'high' || probability === 'high') return 'bg-orange-50';
    if (impact === 'medium' && probability === 'medium') return 'bg-yellow-50';
    return 'bg-green-50';
  };

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr>
            <th className="p-4"></th>
            {impactLevels.map(impact => (
              <th key={impact} className="p-4 text-sm font-medium text-gray-900 text-center">
                Impact: {impact.charAt(0).toUpperCase() + impact.slice(1)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {probabilityLevels.map((probability, rowIndex) => (
            <tr key={probability}>
              <td className="p-4 text-sm font-medium text-gray-900">
                Probability: {probability.charAt(0).toUpperCase() + probability.slice(1)}
              </td>
              {impactLevels.map((impact, colIndex) => {
                const cellRisks = getRisksForCell(impact, probability);
                return (
                  <td
                    key={`${impact}-${probability}`}
                    className={`p-4 border ${getCellColor(impact, probability)}`}
                  >
                    <div className="space-y-2">
                      {cellRisks.map(risk => (
                        <button
                          key={risk.id}
                          onClick={() => onRiskSelect(risk)}
                          className="w-full text-left p-2 text-sm bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow"
                        >
                          <p className="font-medium text-gray-900">{risk.title}</p>
                          <p className="text-xs text-gray-500 mt-1">{risk.category}</p>
                        </button>
                      ))}
                    </div>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}